export class RegisterUserRequest {
  constructor(
    public email: string | null,
    public firstName: string | null,
    public lastName: string | null,
    public code: number | null,
    public phoneNumber: string | null,
    public organizationName: string | null,
    public password: string | null
  ) {}
}
